import { withWizardRefetch } from "../withWizardRefetch.js";
import { useDecisionManagementBox_ModifyWizardSettingsMutation } from "./DecisionManagementBox.generated.js";

export const useDecisionManagementBox_ModifyWizardSettingsMutationWithWizardRefetch =
  withWizardRefetch(useDecisionManagementBox_ModifyWizardSettingsMutation);
